<div class="modal-header">
  <div class="flex-container align-items-center">
    <button type="button" class="btn-close me-2 d-inline-flex" data-bs-dismiss="modal" aria-label="Close"></button>
    <span class="page-title">{{ summary().crn }}</span>
  </div>
</div>
<form class="modal-body d-flex flex-column gap-5 p-5" [formGroup]="form">
  <div class="card">
    <div class="card-body p-5">
      <app-operational-port-authority-editor [summary]="summary()"
                                             [isIncomingTrip]="isIncomingTrip()"
                                             [isOutgoingTrip]="isOutgoingTrip()"
      />
    </div>
  </div>
  <div class="card">
    <div class="card-body p-5">
      <app-operational-services-editor [portUnCode]="summary().portUnCode" />
    </div>
  </div>
  <div class="card">
    <div class="card-body p-5">
      <app-operational-berth-editor [portUnCode]="summary().portUnCode"
                                    [isIncomingTrip]="isIncomingTrip()"
                                    [isOutgoingTrip]="isOutgoingTrip()"
      />
    </div>
  </div>
</form>
<div class="modal-footer">
  <div class="float-end">
    <button type="button" class="btn btn-outline-secondary me-3 footer-button" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary footer-button" (click)="save()">Save</button>
  </div>
</div>
